// src/services/api.js
import axios from 'axios';

// Public endpoints (no token required)
const publicEndpoints = [
  '/auth/login', '/auth/register', '/auth/verify', '/auth/verify-email',
  '/auth/forgot-password', '/auth/reset-password',
];

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5050/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Request interceptor – add token only for protected endpoints
api.interceptors.request.use(
  (config) => {
    const isPublic = publicEndpoints.some(url => config.url.includes(url));
    if (isPublic) return config;

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('⚠️ No token for protected request:', config.url);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor – handle 401 globally (skip public endpoints)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestedUrl = error.config?.url || '';
      if (!publicEndpoints.some(url => requestedUrl.includes(url))) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;